import { render, staticRenderFns } from "./AboutLinks.vue?vue&type=template&id=668a0a70&scoped=true"
import script from "./AboutLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutLinks.vue?vue&type=style&index=0&id=668a0a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a0a70",
  null
  
)

export default component.exports